// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"fb400416","588":"3b42ce6b"}[chunkId] + ".chunk.css";
};